import React from 'react'
import { useTranslation } from 'react-i18next';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import Grid2 from '@mui/material/Unstable_Grid2/Grid2';
import { DateCellStyling,ContainerStyling,HeadingStyling,ContentCellStyling,TableRowStyling} from './BiogTableStyles';

export default function BiogArticles(props) {
  const { t } = useTranslation('common');

  return (
    <>
    <Grid2 flexDirection="row" sx={ContainerStyling}>
        <TableContainer >
          <Table size="small" aria-label="a dense table">
            <TableBody>
              {props.articles.map((article, index) => (
                <TableRow
                  key={article.id}
                  sx={TableRowStyling}
                >
                  <TableCell component="td" padding="none" scope="row" sx={DateCellStyling}>
                    {article.year}
                  </TableCell>
                  <TableCell align="left" padding="none" sx={ContentCellStyling}>
                    <Box sx={{fontWeight : 'bold'}} component='span'>{article.publication}</Box>
                    {!!(article.location)?<Box sx={{fontWeight : 'normal',fontStyle:'italic'}} component='span'>, {article.location}</Box>:null}
                    <Box sx={{fontWeight : 'normal'}} component='span'>, {article.edition}</Box>
                    {!!(article.title)?<Box sx={{fontWeight : 'normal',fontStyle:'italic'}} component='span'> - {article.title}</Box>:null}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Grid2>
    </>
  )
}
